enum Currency {
    USD = 'USD - $',
    EUR = 'EUR - €',
};

export default Currency;
